import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { config } from "../constants/config";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import UserContext from "../contexts/UserContext";
import { textes } from "../constants/textes";
import HomeDashbord from "../components/dashbords/maindashbord";
import RevendeurDashbord from "../components/dashbords/revendeurdashbord";
import { Cash, CreditCard } from "react-bootstrap-icons";
import EnRegleState from "../components/enreglestate";



export default function Dashboard() {
    // states
    const { user, logoutUser } = useContext(UserContext);
    const navigate = useNavigate();

    // const [fetching, setFetching] = useState(false);

    // const [page, setPage] = useState(0);
    const [solde, setsolde] = useState(0);
    const [retenu, setretenu] = useState(0);

    // const currentdate = new Date().toLocaleDateString('en-GB', {
    //     year: 'numeric',
    //     month: '2-digit',
    //     day: '2-digit',
    // }).split('/').reverse().join('-');
    // const currentmonth = new Date().getMonth();
    // const currentyear = new Date().getFullYear();

    // const numStr = (a, b) => {
    //     a = '' + a;
    //     b = b || ' ';
    //     var c = '',
    //         d = 0;
    //     while (a.match(/^0[0-9]/)) {
    //       a = a.substr(1);
    //     }
    //     for (var i = a.length-1; i >= 0; i--) {
    //       c = (d !== 0 && d % 3 === 0) ? a[i] + b + c : a[i] + c;
    //       d++;
    //     }
    //     return c;
    //   }

    // const showErrorMessage = (msg) => {
    //     toast.error(msg, {
    //         position: toast.POSITION.BOTTOM_CENTER,
    //         autoClose: 5000,
    //         hideProgressBar: false,
    //         closeOnClick: true,
    //         pauseOnHover: true,
    //         draggable: true,
    //         progress: undefined,
    //         theme: "colored",
    //     });
    // }

    // const showSuccesMessage = (msg) => {
    //     toast.success(msg, {
    //         position: toast.POSITION.BOTTOM_CENTER,
    //         autoClose: 5000,
    //         hideProgressBar: false,
    //         closeOnClick: true,
    //         pauseOnHover: true,
    //         draggable: true,
    //         progress: undefined,
    //         theme: "colored",
    //     });
    // }

    const getRevendeur = async () => {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/users?type=revendeur&codeutilisateur=${user?.codeutilisateur}`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let body = data?.body?.data[0];

                        setsolde(Number.parseInt(body?.solde));
                        setretenu(Number.parseInt(body?.retenu));
                        // setrevendeur(body?.code);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            // console.log("server error", err);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("statut error", err);
            }

        }).catch((err) => {
            console.log("error get reventeurs list", err);
            // setError(true);
            // setLoading(false);
        });
    }

    const displayPages = () => {
        // if(page === 0){ 
        //     return <NfcDashbord day={currentdate} month={currentmonth} year={currentyear} />;
        // } else if (page === 1) {
        //     return <QrcodeDashbord day={currentdate} month={currentmonth} year={currentyear} />;
        // } else if (page === 2) {
        //     return <OQrcodeDashbord day={currentdate} month={currentmonth} year={currentyear} />;
        // } else if (page === 3) {
        //     return <AuthDashbord day={currentdate} month={currentmonth} year={currentyear} />;
        // } else {
        //     return <ControlDashbord day={currentdate} month={currentmonth} year={currentyear} />;
        // }
    }




    // comportements
    useEffect(() => {
        getRevendeur();
    }, []);

    //affichage 
    return (

        <div className="container-fluid">
            {/* <div className="row">
                <div className="col-md-12 mb-3">
                    <EnRegleState />
                </div>
            </div> */}
            {(!user?.isFullAction && !user?.isAdminAction) && <div className="row">
                <div className="col-md-12 mb-3">
                    {/* <div className="card border-left-danger shadow h-auto py-2" style={{float: "right", width:"248px"}}>
                        <div className="card-body" style={{padding:"0.5rem 1.25rem"}}>
                            <div className="row no-gutters align-items-center">
                                <div className="col mr-2">
                                    <div className="text-xs font-weight-bold text-danger text-uppercase mb-1">
                                        Retenue / achat de forfait </div>
                                    <div className="h5 mb-0 font-weight-bold text-gray-800">{retenu} %</div>
                                </div>
                                <div className="col-auto">
                                    <Cash className="text-danger" style={{ fontSize: 36 }} />
                                </div>
                            </div>
                        </div>
                    </div> */}
                    <div className="card border-left-success shadow h-auto py-2" style={{float: "right", width:"248px"}}>
                        <div className="card-body" style={{padding:"0.5rem 1.25rem"}}>
                            <div className="row no-gutters align-items-center">
                                <div className="col mr-2">
                                    <div className="text-xs font-weight-bold text-success text-uppercase mb-1">
                                        Votre Solde </div>
                                    <div className="h5 mb-0 font-weight-bold text-gray-800">{solde} XAF</div>
                                </div>
                                <div className="col-auto">
                                    <Cash className="text-success" style={{ fontSize: 36 }} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <h1 className="h4 mt-5 font-weight-bold text_primary"><i className="fa fa-tachometer-alt mr-1"></i> {textes.fr.dashbordlabel}</h1>
                </div>
            </div>}

            {(user?.isFullAction || user?.isAdminAction) && <h1 className="h4 mb-4 font-weight-bold text_primary"><i className="fa fa-tachometer-alt mr-1"></i> {textes.fr.dashbordlabel}</h1>}

            <div className="row">
                {(user?.isFullAction || user?.isAdminAction) ? <HomeDashbord /> : <RevendeurDashbord />}
            </div>

            <div className="row">
                <div className="col-md-12 mb-3">

                </div>
                {displayPages()}
            </div>

            <ToastContainer />
        </div>

    )
}